import { CART_RECEIVE, CART_SHOW_INFO, CART_SET_LAST_ADDED } from '../constants';

export const cart = (
    state = {
        quantity: 0,
        orderTotal: 0,
        showInfo: false,
        lastAdded: null
    },
    action
) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_SHOW_INFO:
        case CART_SET_LAST_ADDED:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
